import React from 'react'
import "./Order_details_table.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Table } from 'react-bootstrap'

function Order_details_table({
  order,
  dontShowPrice,
  productId,
  setProductId,
  setShowReviewRating,
  showReviewRating,
}) {

  const handleOpenReview = async (productDetail) => {
    await setProductId(productDetail?.product_id);
    await setShowReviewRating(true);
  };
  return (
    <>
      {
        order?.Product_Order_Details?.map((product) => (
          <div className='product_content_holder'>
            <div className='product_content'>
              <div className='product_detail_inner'>
                <div className='left_side'>
                  <div className='img_holder'>
                    <img
                      src={
                        process.env.REACT_APP_IMG_URL +
                        product?.Product?.image
                      }
                    />
                  </div>

                  <div className='text_holder'>
                    <div className='product_name'>
                      <p>{product?.Product?.name}</p>
                    </div>
                    <div className='weight'>
                      <p>{product?.Product_Variant?.name} {product?.Product?.Unit?.name}</p>
                    </div>
                  </div>
                </div>

                <div>
                  <div className='qty_holder'>
                    <p>X{product?.quantity}   ₹{!dontShowPrice && <span className='price'>{Number(product?.Product_Variant?.price).toFixed(2)}</span>}</p>
                  </div>
                </div>
              </div>

              
              {Number(order?.order_status_id) === 5 && order?.Rating_Review === null && (
                <div className="mt-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleOpenReview(product)}
                  >
                    Review & Rating
                  </button>
                </div>
              )}
            </div>
          </div>

        ))
      }
      {/* <div className='product_content_holder'>
        <div className='product_content'>
          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.REACT_APP_IMG_URL +
                    order?.Product_Order_Details?.Product?.image
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>{order?.Product_Order_Details?.Product_Variant?.name}</p>
                </div>
                <div className='weight'>
                  <p>{order?.total_kg}</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>

          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/products/img2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Apple</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>
        </div>
      </div> */}
    </>
  )
}

export default Order_details_table
